import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useStore } from '../components/state/zustand-store';

export default function ShowableDialog(): React.JSX.Element {
  const { error, setCloseShowable, openShowable } = useStore();

  let actionButton = (
    <Button onClick={() => setCloseShowable()} autoFocus variant="contained">
      Okay
    </Button>
  );

  if (
    error.exceptionType === 'RefreshOption' ||
    error.exceptionType === 'ForceRefresh' ||
    error.header === 'Session Expired'
  ) {
    actionButton = (
      <Button
        onClick={() => {
          setCloseShowable();
          window.location.reload();
        }}
        autoFocus
        variant="contained"
      >
        Refresh
      </Button>
    );
  }

  return (
    <Dialog
      open={openShowable}
      onClose={() => setCloseShowable()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
    >
      <DialogTitle id="alert-dialog-title">
        {error.header || 'There was an issue!'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {error.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>{actionButton}</DialogActions>
    </Dialog>
  );
}
